var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"item",attrs:{"value":_vm.count > 0 ? _vm.count : '',"max":100,"title":"消息提醒"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }